/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { useNavigate, useLocation } from 'react-router-dom'

import { QUERY_KEYS } from '@api'
import { Filters, RoleEnum, StatusTicketEnum } from '@types'
import { useGeneral, useUser } from '@contexts'
import { ROUTE_KEYS } from '@constants'

import { TicketsApi } from './api'

export const useGetTickets = (filters?: Filters) => {
  const { t } = useTranslation()
  const { ticketToSearch } = useGeneral()
  const { ADMIN, CARRIER, SUPPLIER } = RoleEnum
  const { state: user } = useUser()
  const { PENDING } = StatusTicketEnum
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const roles = user?.roles.map(role => role.name)
  const gmtZone = user?.company?.gmtZone ?? 0
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.TICKETS, filters, ticketToSearch, gmtZone],
    () =>
      TicketsApi.getTickets({
        filters: ticketToSearch ? { ticketId: ticketToSearch } : filters,
        gmtZone,
      }),
    {
      refetchInterval: false, // Deshabilitar refetch automático - usamos WebSockets en su lugar
      staleTime: 5 * 60 * 1000, // 5 minutos - los datos se mantienen frescos por más tiempo
      refetchOnWindowFocus: false, // Deshabilitar refetch al hacer focus en la ventana
      refetchOnReconnect: false, // Deshabilitar refetch al reconectar la red
      onError: () => {
        notification.error({
          message: t('admin_router.admin_dashboard.contracts.notifications.api_error'),
        })
      },
      onSuccess: response => {
        if (ticketToSearch && response?.tickets?.length === 1) {
          const ticket = response.tickets[0]

          const now = dayjs()
          const ticketDayjs = dayjs(ticket.withdrawalDate)
          if (roles?.includes(ADMIN)) {
            if (pathname === ROUTE_KEYS.ADMIN.EVOUCHERS) {
              if (ticketDayjs > now) {
                navigate(ROUTE_KEYS.ADMIN.ONGOING)
              }
            }
          } else if (roles?.includes(CARRIER)) {
            if (ticketDayjs < now) {
              if (pathname !== ROUTE_KEYS.ADMIN.EVOUCHERS) {
                navigate(ROUTE_KEYS.CARRIER.EVOUCHERS)
              }
            } else if (pathname !== ROUTE_KEYS.CARRIER.HOME && ticket.status.name === PENDING) {
              navigate(ROUTE_KEYS.CARRIER.HOME)
            } else if (pathname !== ROUTE_KEYS.CARRIER.ALL && ticket.status.name !== PENDING) {
              navigate(ROUTE_KEYS.CARRIER.ALL)
            }
          } else if (roles?.includes(SUPPLIER)) {
            if (pathname !== ROUTE_KEYS.SUPPLIER.HOME) {
              if (ticketDayjs > now) {
                navigate(ROUTE_KEYS.SUPPLIER.HOME)
              }
            } else if (pathname !== ROUTE_KEYS.SUPPLIER.PREVIOUS) {
              if (ticketDayjs < now) {
                navigate(ROUTE_KEYS.SUPPLIER.PREVIOUS)
              }
            }
          }
        }
      },
    },
  )
  return { tickets: data, ticketsIsLoading: isLoading }
}
